/**
 * Custom header — inline predictive search panel toggle (desktop).
 */
(function () {
  const INLINE_SELECTOR = '.header-search--inline';

  function initInlineSearch(wrapper) {
    const form = wrapper.querySelector('form[role="search"]');
    const input = wrapper.querySelector('input[type="search"]');
    const predictive = wrapper.querySelector('predictive-search.predictive-search--inline');

    if (!form || !input || !predictive) return;

    const open = () => predictive.classList.add('is-open');
    const close = () => predictive.classList.remove('is-open');

    input.addEventListener('focus', open);

    input.addEventListener('input', () => {
      if (input.value.trim().length > 0) open();
      else close();
    });

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  }

  function init() {
    document.querySelectorAll(INLINE_SELECTOR).forEach(initInlineSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(INLINE_SELECTOR).forEach(initInlineSearch);
  });
})();
